import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useNavigate } from 'react-router-dom';
import { useServiceRequest } from '../../../components/ServiceStatusProvider';

const EmptyOrderState = ({ phoneNumber }) => {
  const navigate = useNavigate();
  const { requestCleaning } = useServiceRequest();

  return (
    <div className="w-full rounded-lg bg-card p-8 shadow-lg transition-all duration-300 hover:shadow-xl sm:p-12">
      <div className="flex flex-col items-center text-center">
        <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-muted">
          <Icon name="PackageX" size={40} className="text-muted-foreground" />
        </div>

        <h3 className="mb-2 text-xl font-bold text-foreground">주문 내역이 없습니다</h3>
        <p className="mb-6 text-sm text-muted-foreground">
          {phoneNumber ? (
            <>
              <span className="font-medium">{phoneNumber}</span>로 등록된 주문이 없습니다.
              <br />
              전화번호를 다시 확인해주세요.
            </>
          ) : (
            '조회된 주문 내역이 없습니다.'
          )}
        </p>

        <div className="flex w-full max-w-md flex-col gap-3 sm:flex-row">
          <Button
            variant="default"
            fullWidth
            iconName="Plus"
            iconPosition="left"
            onClick={() => requestCleaning()}
          >
            새 주문하기
          </Button>
          <Button
            variant="outline"
            fullWidth
            iconName="Phone"
            iconPosition="left"
            onClick={() => window.location.href = 'tel:1588-0000'}
          >
            고객센터 문의
          </Button>
        </div>

        <div className="mt-8 w-full max-w-md rounded-lg bg-muted/50 p-4">
          <div className="flex items-start space-x-3">
            <Icon name="HelpCircle" size={20} className="mt-0.5 text-primary" />
            <div className="flex-1 text-left">
              <p className="text-sm font-medium text-foreground">도움이 필요하신가요?</p>
              <ul className="mt-2 space-y-1 text-xs text-muted-foreground">
                <li>• 주문 시 입력한 전화번호를 확인해주세요</li>
                <li>• 최근 6개월 이내 주문만 조회 가능합니다</li>
                <li>• 문의사항은 고객센터로 연락주세요</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyOrderState;